/**
 * Affichage commissions — config active = seule source de vérité UI.
 * Miroir de backend/utils/commissions.py → compute_commission_amount (sans I/O).
 */

export function formatCommissionRate(percent, fixed) {
  const pct = Number(percent) || 0;
  const fix = Number(fixed) || 0;
  const parts = [];
  if (pct > 0) parts.push(`${pct}%`);
  if (fix > 0) parts.push(`${fix} €`);
  return parts.length ? parts.join(' + ') : '—';
}

/**
 * @param {object|null|undefined} staffCommissionsConfig — users.commissions
 * @param {{ type?: string, transaction_amount?: number }} line
 */
export function resolveCommissionDisplay(staffCommissionsConfig, line) {
  const ctype = line?.type;
  const amount = Number(line?.transaction_amount) || 0;

  if (!ctype || amount <= 0) {
    return {
      applies: false,
      ratePercent: 0,
      rateFixed: 0,
      commissionAmount: 0,
      rateLabel: '—',
    };
  }

  const cfg = staffCommissionsConfig?.[ctype];
  if (!cfg?.enabled) {
    return {
      applies: false,
      ratePercent: 0,
      rateFixed: 0,
      commissionAmount: 0,
      rateLabel: '—',
    };
  }

  const ratePercent = Number(cfg.rate_percent) || 0;
  const rateFixed = Number(cfg.rate_fixed) || 0;

  if (ratePercent <= 0 && rateFixed <= 0) {
    return {
      applies: false,
      ratePercent: 0,
      rateFixed: 0,
      commissionAmount: 0,
      rateLabel: '—',
    };
  }

  const commissionAmount = Math.round((amount * ratePercent / 100 + rateFixed) * 100) / 100;

  return {
    applies: commissionAmount > 0,
    ratePercent,
    rateFixed,
    commissionAmount,
    rateLabel: formatCommissionRate(ratePercent, rateFixed),
  };
}
